export function MonthlySipEmptyStateIcon() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 24C42 33.9411 33.9411 42 24 42C14.0589 42 6 33.9411 6 24C6 14.0589 14.0589 6 24 6"
        stroke="#78716C"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M24 6C33.9411 6 42 14.0589 42 24"
        stroke="#78716C"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeDasharray="3.12 3.12"
      />
      <path
        d="M21.6723 10.4228L25.915 6.18017L21.6723 1.93753"
        stroke="#78716C"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.375 21.5874H30.375"
        stroke="#78716C"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.375 16.5H30.375"
        stroke="#78716C"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.75 16.5C23.0429 16.5 24.2829 17.0359 25.1971 17.9899C26.1114 18.9439 26.625 20.2378 26.625 21.587C26.625 22.9361 26.1114 24.23 25.1971 25.184C24.2829 26.138 23.0429 26.6739 21.75 26.6739H18.375L26.625 34.5"
        stroke="#78716C"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
